/**  Common for image data construction for the altAssets and assetAuditors */
import { useSelector } from "react-redux";
import { db, helpers } from "../common/lib";
import { get, set, update } from "idb-keyval";

// Mock functions to replace the hook calls
const fetchGroupAuditsDetails = async (audits, auditId) => {
    let audit = helpers.list.getItemForId(audits, auditId);

    let auditAltAssets = (await get(db.types.altAsset)) || [];
    let requiredAssets = (await get(db.types.auditAsset)) || [];
    let assetAuditors = (await get(db.types.assetAuditor)) || [];
    let typesList = (await get(db.types.typesList)) || [];

    if (audit.auditReference && !isNaN(audit.auditReference)) {
        if (Object.keys(audit).length > 0) {
            const auditRef = parseInt(audit.auditReference);
            auditAltAssets = auditAltAssets.filter(
                (item) => item.audit.id === parseInt(auditId)
            );

            /**
             * 1. Filter out assetAuditor for the audit
             */
            assetAuditors = assetAuditors.filter(
                (item) =>
                    parseInt(
                        item.auditAssignment.auditLocation.audit.auditReference
                    ) === parseInt(auditRef)
            );

            const auditedAssets = requiredAssets.filter(
                (item) =>
                    parseInt(item.auditLocation.audit.auditReference) ===
                        parseInt(auditRef) && item.isAssigned
            );

            const getVin = (assetId) =>
                auditedAssets.find((item) => item.id === assetId).assetCore
                    .identifier1;

            /** Get the summary of the audit
             * 1. Seen assets
             * 2. Excluded asset
             *  a. Get the vin of the excluded asset
             *  b. Get the exclusion reason of the asset
             */

            let excludedAsset = 0,
                seenAsset = 0,
                excludedAssetList = [];

            assetAuditors.map((item) => {
                if (item.exclusionReason && typesList.exclusionReasonTypes) {
                    excludedAssetList.push({
                        vin: getVin(item.auditAsset.id),
                        exclusionReason: helpers.list.getItemForId(
                            typesList.exclusionReasonTypes,
                            item.exclusionReason
                        ).name,
                    });
                    excludedAsset++;
                } else {
                    seenAsset++;
                }
            });

            requiredAssets = requiredAssets.filter(
                (item) =>
                    parseInt(item.auditLocation.audit.auditReference) ===
                        parseInt(auditRef) &&
                    item.isMandatory &&
                    item.isExpected &&
                    !item.isAssigned
            );

            /**  Filter out
             * 1. Mandatory assets  and Expected assets
             * 2. Assigned items false
             * Should  consider only mandatory assets as we only want them in the list
             */

            const assignedAssets = requiredAssets.filter(
                (i) =>
                    parseInt(i.auditLocation.audit.auditReference) ===
                        parseInt(auditRef) &&
                    i.isAssigned &&
                    i.isMandatory &&
                    i.isExpected
            );

            return {
                groupedUnexpectedAsset: auditAltAssets.length,
                groupedAssignedAsset: auditedAssets.length,
                groupedSeenAsset: seenAsset,
                groupedExcludedAsset: excludedAsset,
                groupedExcludedAssetList: excludedAssetList,
                groupedComplete:
                    requiredAssets.length - assignedAssets.length === 0,
                groupedRequired: requiredAssets.length,
            };
        }
    }
};

const fetchAuditProgressDetails = async (audits, auditId) => {
    // Replace this with your actual data-fetching logic
    let audit = helpers.list.getItemForId(audits, auditId);
    let auditAltAssets = (await get(db.types.altAsset)) || [];
    let requiredAssets = (await get(db.types.auditAsset)) || [];
    let assetAuditors = (await get(db.types.assetAuditor)) || [];
    let typesList = (await get(db.types.typesList)) || [];

    if (Object.keys(audit).length > 0) {
        auditAltAssets = auditAltAssets.filter(
            (item) => item.audit.id === parseInt(auditId)
        );

        /**
         * 1. Filter out assetAuditor for the audit
         */

        assetAuditors = assetAuditors.filter(
            (item) =>
                item.auditAssignment.auditLocation.audit.id ===
                parseInt(auditId)
        );

        /**  Filter out
         * 1. Mandatory assets  and checked assets
         * 2. Assigned items false
         * Should  consider only mandatory assets as we only want them in the list
         */

        const auditedAssets = requiredAssets.filter(
            (item) =>
                item.auditLocation.audit.id === parseInt(auditId) &&
                item.isAssigned
        );

        const getVin = (assetId) =>
            auditedAssets.find((item) => item.id === assetId).assetCore
                .identifier1;

        /** Get the summary of the audit
         * 1. Seen assets
         * 2. Excluded asset
         *  a. Get the vin of the excluded asset
         *  b. Get the exclusion reason of the asset
         */

        let excludedAsset = 0,
            seenAsset = 0,
            excludedAssetList = [];

        if (typesList.exclusionReasonTypes)
            assetAuditors.map((item) => {
                if (item.exclusionReason) {
                    excludedAssetList.push({
                        vin: getVin(item.auditAsset.id),
                        exclusionReason: helpers.list.getItemForId(
                            typesList.exclusionReasonTypes,
                            item.exclusionReason
                        ).name,
                    });
                    excludedAsset++;
                } else {
                    seenAsset++;
                }
            });

        requiredAssets = requiredAssets.filter(
            (item) =>
                item.auditLocation.audit.id === parseInt(auditId) &&
                item.isMandatory &&
                item.isExpected &&
                !item.isAssigned
        );

        /**  Filter out
         * 1. Mandatory assets  and Expected assets
         * 2. Assigned items false
         * Should  consider only mandatory assets as we only want them in the list
         */

        const assignedAssets = requiredAssets.filter(
            (i) =>
                i.auditLocation.audit.id === parseInt(auditId) &&
                i.isAssigned &&
                i.isMandatory &&
                i.isExpected
        );

        return {
            alt: auditAltAssets.length,
            assigned: auditedAssets.length,
            seen: seenAsset,
            excluded: excludedAsset,
            excludedAssetList: excludedAssetList,
            isComplete: requiredAssets.length - assignedAssets.length === 0,
            required: requiredAssets.length,
        };
    }
};

const fetchMakeDetails = async (orgId, makeId) => {
    let typesList = (await get(db.types.typesList)) || [];
    if (orgId) {
        const currentOrg = typesList.find((item) => item.orgId === orgId);
        const currentMake =
            currentOrg &&
            currentOrg.typesList.makes.find((item) => item.id === makeId);
        return currentMake?.name;
    } else return "";
};

export default {
    fetchGroupAuditsDetails,
    fetchAuditProgressDetails,
    fetchMakeDetails,
};
/***TODO
 * 1. cleanAllGroupData test case
 */
